
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import NotFound from './common/components/NotFound';
import Login from './common/components/Login';

const Routes = (props) => (
    <Switch>
        <Route exact path="/" component={Login} />
        <Route component={NotFound} />
    </Switch>
);
export default Routes;